import { trigger, animate, transition, style, state } from '@angular/animations';

export const DrawerAnimation = trigger('DrawerAnimation', [
  state(
    'open',
    style({
      transform: 'translateY(0)',
      transition: 'transform 600ms cubic-bezier(0.68, -0.55, 0.3, 1.3)',
    }),
  ),
  state(
    'closed',
    style({
      height: '52px',
      transition: 'transform 600ms cubic-bezier(0.68, -0.55, 0.3, 1.3)',
    }),
  ),
  transition('closed <=> open', animate('600ms cubic-bezier(0.68, -0.55, 0.3, 1.3)')),
]);
